import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

import { AttributeCardDisplayVariantType } from "./types";

import { type UserProfileAttributes } from "@/schemas/profile/UserProfileAttributes";
import { type AppUserSession } from "@/schemas/auth/session";
import HeightSelection from "@/Components/PersonalAttributes/Attributes/Height";
import WeightSelection from "@/Components/PersonalAttributes/Attributes/Weight";
import BodySelection from "@/Components/PersonalAttributes/Attributes/Body";
import EthnicitySelection from "@/Components/PersonalAttributes/Attributes/Ethnicity";

type PhysicalAttributesProps = {
  session: AppUserSession;
  attributes: Partial<UserProfileAttributes>;
  variant: AttributeCardDisplayVariantType;
};

function PhysicalAttributes({
  session,
  attributes,
  variant,
}: PhysicalAttributesProps): React.JSX.Element {
  const isAccountScreen = variant === AttributeCardDisplayVariantType.ACCOUNT;

  return (
    <View style={isAccountScreen ? styles.container : null}>
      {isAccountScreen && (
        <View style={styles.sectionContainer}>
          <Ionicons name="body-outline" size={25} color="#01579b" />
          <Text style={styles.sectionTitle}>{"Physical Attributes"}</Text>
        </View>
      )}
      <View style={styles.grid}>
        <HeightSelection
          session={session}
          heightValue={attributes.height || null}
          variant={variant}
        />
        <WeightSelection
          session={session}
          weightValue={attributes.weight || null}
          variant={variant}
        />
        <BodySelection
          session={session}
          bodyValue={attributes.bodyType || null}
          variant={variant}
        />
        <EthnicitySelection
          session={session}
          ethnicityValue={attributes.ethnicity || null}
          variant={variant}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  sectionContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
  },
  sectionTitle: {
    fontSize: 20,
    marginLeft: 5,
    fontWeight: "bold",
  },
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
});

export default PhysicalAttributes;
